import { Component, OnInit, ViewChild, ElementRef, Inject, Optional } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatOption } from '@angular/material/core';
import { sortByFirstLetter } from 'src/app/utils/autoSelect';
import { CodebookService } from 'src/services/codebook.service';
import { CpsuSubjectService } from 'src/services/cpsu-subject.service';
import { ToastrImplService } from 'src/services/toastr.service';
enum AutocompleteFilterEnum {
   CENTERS = 'centers',
}
@Component({
   selector: 'app-input-subject-in-cpsu',
   templateUrl: './input-subject-in-cpsu.component.html',
   styleUrls: ['./input-subject-in-cpsu.component.scss'],
})
export class InputSubjectInCpsuComponent implements OnInit {
   cpsuFormAdd: FormGroup;
   centers: any;
   @ViewChild('allSelectedCenters') private allSelectedCenters: MatOption;
   @ViewChild('multiSearch') private multiSearch: ElementRef;
   filteredAllCenters: any = [];

   constructor(
      private formBuilder: FormBuilder,
      public dialogRef: MatDialogRef<any>,
      @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
      public dialog: MatDialog,
      private codebookService: CodebookService,
      private cpsuSubjectService: CpsuSubjectService,
      private toastr: ToastrImplService
   ) {}

   ngOnInit(): void {
      this.codebookService.getAllCpsuCenter().subscribe(result => {
         this.centers = result.filter((c: any) => c.id !== 1).sort((a: any, b: any) => a.name.localeCompare(b.name));
      });
      this.cpsuFormAdd = this.formBuilder.group({
         center: [null],
         fosterParentData: [this.data.fosterParentData || ''],
         fosterChildData: [this.data.fosterChildData || ''],
         insertFosterParentCheck: [false],
      });

      this.cpsuFormAdd.get('center')!.valueChanges.subscribe((val: any) => {
         const selected: any[] = Array.isArray(val) ? val.filter(x => x !== 0) : [];
         if (selected.length !== 1) {
            this.cpsuFormAdd.get('insertFosterParentCheck')!.setValue(false, { emitEvent: false });
         }
      });
   }

   sendRequest() {
      var body = null;
      if (this.data.isFosterChild) {
         body = {
            isFosterParent: false,
            fromCsrId: this.data.fromCsrId,
            cpsuIds: this.cpsuFormAdd.value.center.filter(x => x !== 0),
            fosterChildSubjectId: this.data.fosterChildSubjectId,
            fosterParentSubjectId: this.cpsuFormAdd.value.insertFosterParentCheck ? this.data.fosterParentSubjectId : null,
         };
      } else {
         body = {
            isFosterParent: true,
            fromCsrId: this.data.fromCsrId,
            cpsuIds: [this.cpsuFormAdd.value.center],
            fosterParentSubjectId: this.data.fosterParentSubjectId,
         };
      }

      this.cpsuSubjectService.insertSubjectInCpsu(body).subscribe(
         result => {
            this.toastr.success('CASES.CPSU.ADD_TO_CPSU_SUCCESS');
            this.dialogRef.close({ event: 'success', data: body });
         },
         error => {
            this.toastr.error('SNACKBAR.ERROR_OCCURRED');
         }
      );
   }

   closeDialog() {
      this.dialogRef.close({ event: 'cancel' });
   }
   onInputChange(inputValue: string) {
      const input = inputValue.toLowerCase();
      if (input.trim() == '') {
         this.filteredAllCenters = this.centers;
      } else {
         this.filteredAllCenters = this._filter(input, AutocompleteFilterEnum.CENTERS);
      }
   }
   selectMulti() {
      this.multiSearch.nativeElement.focus();
      this.multiSearch.nativeElement.value = null;
      this.filteredAllCenters = this.centers;
   }

   toggleAllSelectionCenter() {
      if (this.allSelectedCenters.selected) {
         this.cpsuFormAdd.controls.center.patchValue([...this.centers.map(item => item.id), 0]);
      } else {
         this.cpsuFormAdd.controls.center.patchValue([]);
      }
   }
   tosslePerOneCenter() {
      if (this.allSelectedCenters.selected) {
         this.allSelectedCenters.deselect();
         return false;
      }
      if (this.cpsuFormAdd.controls.center.value.length === this.centers.length) {
         this.allSelectedCenters.select();
      }
   }

   private _filter(value: string, what: AutocompleteFilterEnum): any[] {
      const filterValue = value.toLowerCase();
      switch (what) {
         case AutocompleteFilterEnum.CENTERS:
            const selectedCenters = this.cpsuFormAdd.controls.center.value == null ? [] : this.cpsuFormAdd.controls.center.value;
            return sortByFirstLetter(
               this.centers.filter(option => option.name.toLowerCase().includes(filterValue) || selectedCenters.includes(option.id)),
               filterValue,
               'name'
            );
         default:
            break;
      }
   }
}
